<template lang="pug">
erp-view(
  id="AccesosIndividualesTab"
  ref="AccesosIndividualesTab"
  title="Accesos Individuales"
  :blank="true"
  :hide-header-title="true"
  hide-header-action=true
)
  template(slot="content")
    .form-container
      // === ENCABEZADO: USUARIO ===
      .section
        .section-title.centered
          span.usuario-nombre-badge
            i.fas.fa-user-lock
            | Usuario : {{ modelo.nombreCompleto || 'Sin nombre' }}

      // === SECCIÓN PERMISOS INDIVIDUALES ===
      .section
        .section-header
          .section-icon 🔐
          .section-title Permisos Individuales
        .section-body
          .ed-grid.s-grid-1.m-grid-3.rows-gap.gap-1

            // ---- CLONADOS ----
            .s-cols-1.m-cols-1
              .card.card-dark
                .card-title
                  i.fas.fa-clone
                  | Permisos Clonados ({{ permisosClonados.length }})
                
                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosPermisosClonados")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosPermisosClonados")
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="permisosClonados"
                  display-expr="permiso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosClonados"
                  :search-enabled="true"
                  :search-expr="'permiso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Aplicar a Asignados"
                    type="normal"
                    icon="fa fa-arrow-right"
                    @click="moverSeleccionadosClonadosAAsignados"
                  )

            // ---- ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-green
                .card-title
                  i.fas.fa-check-circle
                  | Permisos Asignados ({{ permisosAsignados.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosPermisosAsignados")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosPermisosAsignados")
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="permisosAsignados"
                  display-expr="permiso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosAsignados"
                  :search-enabled="true"
                  :search-expr="'permiso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Quitar Permisos Seleccionados"
                    type="danger"
                    icon="fa fa-trash"
                    @click="quitarSeleccionadosDeAsignados"
                  )

            // ---- NO ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-red
                .card-title
                  i.fas.fa-times-circle
                  | Permisos No Asignados ({{ permisosDisponibles.length }})
                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosPermisosDisponibles")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosPermisosDisponibles")
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="permisosDisponibles"
                  display-expr="permiso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosDisponibles"
                  :search-enabled="true"
                  :search-expr="'permiso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Asignar al Usuario"
                    type="success"
                    icon="fa fa-arrow-left"
                    @click="moverSeleccionadosDisponiblesAAsignados"
                  )

      // === SECCIÓN PROCESOS INDIVIDUALES ===
      .section.mt-2
        .section-header
          .section-icon ⚙️
          .section-title Procesos ETL Individuales
        .section-body
          .ed-grid.s-grid-1.m-grid-3.rows-gap.gap-1

            // ---- CLONADOS ----
            .s-cols-1.m-cols-1
              .card.card-dark
                .card-title
                  i.fas.fa-clone
                  | Procesos Clonados ({{ procesosClonados.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosProcesosClonados")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosProcesosClonados")
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="procesosClonados"
                  display-expr="proceso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosProcesosClonados"
                  :search-enabled="true"
                  :search-expr="'proceso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Aplicar a Asignados"
                    type="normal"
                    icon="fa fa-arrow-right"
                    @click="moverProcesosClonadosAAsignados"
                  )

            // ---- ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-green
                .card-title
                  i.fas.fa-check-circle
                  | Procesos Asignados ({{ procesosAsignados.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosProcesosAsignados")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosProcesosAsignados")
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="procesosAsignados"
                  display-expr="proceso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosProcesosAsignados"
                  :search-enabled="true"
                  :search-expr="'proceso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Quitar Procesos Seleccionados"
                    type="danger"
                    icon="fa fa-trash"
                    @click="quitarSeleccionadosProcesosDeAsignados"
                  )

            // ---- NO ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-red
                .card-title
                  i.fas.fa-times-circle
                  | Procesos No Asignados ({{ procesosDisponibles.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosProcesosDisponibles")
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosProcesosDisponibles")
                    i.fa.fa-square-mr-1
                    | Quitar selección
                dx-list(
                  :data-source="procesosDisponibles"
                  display-expr="proceso"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosProcesosDisponibles"
                  :search-enabled="true"
                  :search-expr="'proceso'"
                  search-mode="contains"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Asignar al Usuario"
                    type="success"
                    icon="fa fa-arrow-left"
                    @click="moverProcesosDisponiblesAAsignados"
                  )
</template>

<script>
import controlUsuarioResource from "@/api/ControlUsuarioResource.js";

export default {
  name: "AccesosIndividualesTab",
  props: {
    modelo: { type: Object, required: true },
    listas: { type: Object, required: true }
  },
  data() {
    return {
      // === PERMISOS ===
      permisosClonados: [],
      permisosAsignados: [],
      permisosDisponibles: [],
      // === PROCESOS ===
      procesosClonados: [],
      procesosAsignados: [],
      procesosDisponibles: [],
      // === Seleccionados ===
      seleccionadosClonados: [],
      seleccionadosAsignados: [],
      seleccionadosDisponibles: [],

      seleccionadosProcesosClonados: [],
      seleccionadosProcesosAsignados: [],
      seleccionadosProcesosDisponibles: []
    };
  },
  watch: {
    listas: {
      handler(nuevasListas) {
        if (!nuevasListas) return;
        
        this.permisosClonados = nuevasListas.permisosClonados || [];
        this.permisosAsignados = nuevasListas.permisosAsignados || [];
        this.permisosDisponibles = nuevasListas.permisosDisponibles || [];

        this.procesosClonados = nuevasListas.procesosClonados || [];
        this.procesosAsignados = nuevasListas.procesosAsignados || [];
        this.procesosDisponibles = nuevasListas.procesosDisponibles || [];
      },
      deep: true,
      immediate: true
    }
  },
  methods: { 
    seleccionarTodosPermisosClonados() {
      this.seleccionadosClonados = this.permisosClonados;
    }, 
    deseleccionarTodosPermisosClonados() {
      this.seleccionadosClonados = [];
    },
    seleccionarTodosPermisosAsignados() {
      this.seleccionadosAsignados = this.permisosAsignados;
    },

    deseleccionarTodosPermisosAsignados() {
      this.seleccionadosAsignados = [];
    },
    seleccionarTodosPermisosDisponibles() {
      this.seleccionadosDisponibles = this.permisosDisponibles;
    },

    deseleccionarTodosPermisosDisponibles() {
      this.seleccionadosDisponibles = [];
    },
    seleccionarTodosProcesosClonados() {
      this.seleccionadosProcesosClonados = this.procesosClonados;
    },

    deseleccionarTodosProcesosClonados() {
      this.seleccionadosProcesosClonados = [];
    },
    seleccionarTodosProcesosAsignados() {
      this.seleccionadosProcesosAsignados = this.procesosAsignados;
    },

    deseleccionarTodosProcesosAsignados() {
      this.seleccionadosProcesosAsignados = [];
    },
    seleccionarTodosProcesosDisponibles() {
      this.seleccionadosProcesosDisponibles = this.procesosDisponibles;
    },

    deseleccionarTodosProcesosDisponibles() {
      this.seleccionadosProcesosDisponibles = [];
    },

    AsignarPermisos(permisos, usuarioId) {
      controlUsuarioResource
        .asignarPermisos(permisos, usuarioId)
        .then(() => { 
          this.$emit("accesosIndividuales-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Permisos asignados correctamente");
        })
        .catch(err => {
          this.$msg.handleError(err, "Asignar permisos");
        });
    },
    RetirarPermisos(permisos, usuarioId) {
      controlUsuarioResource
        .retirarPermisos(permisos, usuarioId)
        .then(() => {
          this.$emit("accesosIndividuales-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Permisos retirados correctamente");
        })
        .catch(err => {
          this.$msg.handleError(err, "Retirar permisos");
        });
    },
    moverSeleccionadosClonadosAAsignados() {
      if (!this.seleccionadosClonados.length)
        return this.$msg.error("Seleccione al menos un permiso clonado.");
      this.AsignarPermisos(this.seleccionadosClonados, this.modelo.id);
      this.seleccionadosClonados = [];
    },
    quitarSeleccionadosDeAsignados() {
      if (!this.seleccionadosAsignados.length)
        return this.$msg.error("Seleccione al menos un permiso asignado.");
      this.RetirarPermisos(this.seleccionadosAsignados, this.modelo.id);
      this.seleccionadosAsignados = [];
    },
    moverSeleccionadosDisponiblesAAsignados() {
      if (!this.seleccionadosDisponibles.length)
        return this.$msg.error("Seleccione al menos un permiso disponible.");
      this.AsignarPermisos(this.seleccionadosDisponibles, this.modelo.id);
      this.seleccionadosDisponibles = [];
    },

    // === PROCESOS ===
    AsignarProcesos(procesos, usuarioId) {
      controlUsuarioResource
        .asignarProcesos(procesos, usuarioId)
        .then(() => {
          this.$emit("accesosIndividuales-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Procesos asignados correctamente");
        })
        .catch(err => {
          this.$msg.handleError(err, "Asignar procesos");
        });
    },
    RetirarProcesos(procesos, usuarioId) {
      controlUsuarioResource
        .retirarProcesos(procesos, usuarioId)
        .then(() => {
          this.$emit("accesosIndividuales-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Procesos retirados correctamente");
        })
        .catch(err => {
          this.$msg.handleError(err, "Retirar procesos");
        });
    },
    moverProcesosClonadosAAsignados() {
      if (!this.seleccionadosProcesosClonados.length)
        return this.$msg.error("Seleccione al menos un proceso clonado.");
      this.AsignarProcesos(this.seleccionadosProcesosClonados, this.modelo.id);
      this.seleccionadosProcesosClonados = [];
    },
    quitarSeleccionadosProcesosDeAsignados() {
      if (!this.seleccionadosProcesosAsignados.length)
        return this.$msg.error("Seleccione al menos un proceso asignado.");
      this.RetirarProcesos(this.seleccionadosProcesosAsignados, this.modelo.id);
      this.seleccionadosProcesosAsignados = [];
    },
    moverProcesosDisponiblesAAsignados() {
      if (!this.seleccionadosProcesosDisponibles.length)
        return this.$msg.error("Seleccione al menos un proceso disponible.");
      this.AsignarProcesos(this.seleccionadosProcesosDisponibles, this.modelo.id);
      this.seleccionadosProcesosDisponibles = [];
    }
  }
};
</script>

<style scoped>
.list-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}

.list-actions a {
  cursor: pointer;
  font-size: 0.85rem;
  color: #2563eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.list-actions a:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.form-container {
  background: #f8fafc;
  padding: 10px 12px;
  border-radius: 10px;
  max-width: 960px;
  margin: 0 auto;
}
.section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 5px;
  padding: 10px 15px;
}
.section-header { font-weight: 500; display: flex; align-items: center; margin-bottom: 6px; }
.section-icon { font-size: 18px; margin-right: 6px; }
.section-title { font-weight: 500; font-size: 16px; color: #005b99; }
.card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
}
.card-dark { border-color: #111827; }
.card-green { border-color: #10b981; }
.card-red { border-color: #ef4444; }
.card-title {
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}
.card-actions {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.section-title.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-bottom: 10px;
}
.usuario-nombre-badge {
  display: inline-flex;
  align-items: center !important;
  gap: 6px;
  font-weight: 800;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #7dd3fc;
  padding: 2px 14px;
  border-radius: 20px;
  margin-left: 8px;
  font-size: 18px;
}
.usuario-nombre-badge i {
  color: #4acb1f;
}
</style>
